import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root'
})
export class UploadBillService {
  private uploadedExpenseBills: any[] = [];
  private initialActivityDetails: any[] = [];

  addToExpenseList(expenseData: any) {
    debugger;
    console.log('adding data: current list is:  ', this.uploadedExpenseBills)
    let index = _.findIndex(this.uploadedExpenseBills, { 'uniqueId': expenseData.uniqueId })
    if (index < 0) {
      this.uploadedExpenseBills.push(expenseData);
      console.log("expenseDataexpenseData", expenseData);
    } else if (index >= 0) {
      let that = this;
      _.forEach(this.uploadedExpenseBills, function(o) {
        if (o.uniqueId == expenseData.uniqueId) {
          let index = _.findIndex(that.uploadedExpenseBills, { 'uniqueId': expenseData.uniqueId })
          that.uploadedExpenseBills[index] = expenseData;
        }
      })
      this.uploadedExpenseBills.push(expenseData);
    }
  }

  getuploadedExpenseBills() {
    return this.uploadedExpenseBills;
  }

  deleteSelectedBillDetails(selectedBillIndex) {
    // const removeIndex = this.uploadedExpenseBills.findIndex(item => item.basicDetails.refId === selectedBill.basicDetails.refId);

    const updatedBillDetails = this.uploadedExpenseBills.splice(selectedBillIndex, 1);
    console.log('updatedBillDetails: ', updatedBillDetails)
    return updatedBillDetails
  }

  addMultipleBillsToExpenseList(billsList) {
    this.uploadedExpenseBills.push(...billsList);
    console.log('pushed data: ', this.uploadedExpenseBills);
  }

  clearExpenseList() {
    this.uploadedExpenseBills = [];
    return this.uploadedExpenseBills;
  }


  addActivityDetailsToList(activityList) {
    this.initialActivityDetails = activityList
  }

  getActivityDetailsList() {
    return this.initialActivityDetails;
  }

  clearActivityList() {
    this.initialActivityDetails = [];
    return this.initialActivityDetails;
  }
}
